<div class="onboarding">
  <div class="container" *ngIf="step === 1">
    <h4 class="title-one">
      ¡Juntate con amigos y competí por quien genera la mayor ganancia en el nuevo juego de la
      tienda!
    </h4>
    <img class="image" src="/assets/images/ilustration_group.svg" alt="Ilustration" />
    <button class="button-start" (click)="step = 2">
      <span>
        <img class="image" src="/assets/icons/groups/play.svg" alt="Play" />
        Comenzar
      </span>
    </button>
  </div>
  <div class="container" *ngIf="step === 2">
    <h4 class="title-two">¿Cómo se juega?</h4>
    <img class="image-two" src="/assets/images/ilustration_group_two.svg" alt="Ilustration" />
    <ul>
      <li>Creá un grupo, sin costo o unite a alguno, ingresando su código secreto.</li>
      <li>
        Cada grupo tiene 1000 USDT de fantasía para comprar y vender entre las 100 monedas más
        operadas de binance.
      </li>
      <li>El grupo con mayor ganancia luego de 2 semanas se lleva 100 USDT</li>
    </ul>
    <button class="td-btn primary btn-game" (click)="nextStep.emit(step)">Jugar</button>
  </div>
</div>
